
    // Do not modify this file by hand!
    // Re-generate this file by running lit-localize

    
    

    /* eslint-disable no-irregular-whitespace */
    /* eslint-disable @typescript-eslint/no-explicit-any */

    export const templates = {
      's182ab2d6c997515f': `Ajoutez-le à votre écran d'accueil pour une expérience étendue et un accès facile.`,
's224cbcec014ef6b5': `Appuyez sur Partager dans la barre de navigation`,
's37a9e8aec5713460': `Plus`,
's386eca8362ff6155': `Appuyez sur Plus s'il n'y a pas d'icône Partager`,
's4e1e10a6ca408245': `Touchez "Ajouter à l'écran d'accueil"`,
's6196153c4b0c1ea0': `Installer`,
's633502f7cff4f847': `Ouvrez le menu de votre navigateur`,
's681e399d63311fba': `Afficher la galerie`,
's7f0591f08e318eda': `Appuyez sur Plus dans le menu Partager`,
's8114bd55cae5a22b': `Appuyez sur Ajouter au Dock`,
's922329d6f6213590': `Ajouter au Dock`,
's9af56bf005b49c74': `Faites défiler vers le bas jusqu'à "Ajouter à l'écran d'accueil"`,
'sa5ef80b4bb9b39f8': `Moins`,
'sba52286c21552a4e': `Installez-le sur votre appareil pour une expérience complète et un accès facile.`,
'sc16e00a7a8b2fde2': `Retour`,
'scdaf4bbff76674c8': `Ajouter à l'écran d'accueil`,
'se0e473adfda8066c': `Ouvrir dans votre navigateur principal`,
'se740f75b95a51807': `Ajoutez-le à votre Dock pour une expérience étendue et un accès facile.`,
'sfea652f6580ff086': `Ce site possède des fonctionnalités d'application.`,
    };
  